import script from "./PrintComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintComponent.vue?vue&type=script&setup=true&lang=js"

import "./PrintComponent.vue?vue&type=style&index=0&id=794e61bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-794e61bf"]])

export default __exports__